import styled, { keyframes } from "styled-components";

const enterAnimation = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1 }
`;

export const Container = styled.div`
  .outside-close {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0, 0.5);
    z-index: 999;
  }

  animation: ${enterAnimation} 300ms;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;
  overflow: hidden;
  @media (max-width: 1200px) {
    position: relative;
    flex-direction: column;
    height: auto;
  }
`;

export const Section = styled.section`
  //background: ${(props) => props.theme.configs.cor_fundo};
  padding-left: 5px;
  width: 60.41%;
  height: 100%;
  display: flex;
  padding-top: 5.4rem;
  align-items: flex-start;
  flex-direction: column;
  padding-left: 10.7rem;
  padding-bottom: 7%;
  overflow: auto;
  @media (max-width: 1200px) {
    text-align: center;
    margin: 0 0 8rem 0;
    width: 100%;
    padding-left: 0;
  }

  .result {
    max-width: 83%;
    max-height: 664px;
    object-fit: cover;
    object-position: bottom;
  }

  .answer {
    font-family: "Galano";
    line-height: 2.1rem;
    font-size: calc(1.6rem * var(--font-size-scale));
    font-weight: 600;
    font-style: normal;
    //color: ${(props) => props.theme.configs.cor_texto};
    margin-bottom: 2.5rem;
    margin-right: 7.9rem;
    @media (max-width: 1200px) {
      margin: 0 0 6rem 0;
      width: 100%;
      line-height: 2.5rem;
      font-size: calc(2rem * var(--font-size-scale));
      text-align: center;
    }
  }

  .description {
    text-align: left;
    font-family: "Galano";
    line-height: 2.2rem;
    font-size: calc(1.7rem * var(--font-size-scale));
    font-weight: 300;
    font-style: normal;
    letter-spacing: 0.17px;
    //color: ${(props) => props.theme.configs.cor_texto};
    margin: 4rem 0;
    width: 83%;
    @media (max-width: 1200px) {
      text-align: center;
      width: 100%;
    }
  }

  .superscript {
    text-align: right;
    font-family: "Galano";
    line-height: 2.7rem;
    font-size: calc(2rem * var(--font-size-scale));
    font-weight: 600;
    font-style: normal;
    letter-spacing: 0px;
    //color: ${(props) => props.theme.configs.cor_texto};
    @media (max-width: 1200px) {
      text-align: center;
      width: 100%;
    }
  }

  .title {
    text-align: right;
    font-family: "Galano";
    line-height: 3.8rem;
    font-size: calc(3.8rem * var(--font-size-scale));
    font-weight: 600;
    font-style: normal;
    letter-spacing: -0.38px;
    //color: ${(props) => props.theme.configs.cor_texto};
    @media (max-width: 1200px) {
      text-align: center;
      width: 100% !important;
      font-size: calc(3rem * var(--font-size-scale));
      padding: 0 2rem;
    }
  }

  .try-again {
    text-align: left;
    font-family: "Galano";
    line-height: 2.2rem;
    font-size: calc(1.7rem * var(--font-size-scale));
    font-weight: 300;
    font-style: normal;
    letter-spacing: 0.17px;
    //color: ${(props) => props.theme.configs.cor_texto};

    b {
      font-family: "Galano";
      line-height: 2.1rem;
      font-size: calc(1.6rem * var(--font-size-scale));
      font-weight: 600;
      font-style: normal;
      //color: ${(props) => props.theme.configs.cor_texto};
      margin-bottom: 2.5rem;
      margin-right: 7.9rem;
    }
  }
  @media (max-width: 1200px) {
    width: 80%;
    padding-top: 3rem;
    margin: 0;
    display: flex;
  }
`;
export const Gallery = styled.div`
  width: 83%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  & img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: bottom;
  }
  .box {
    margin-top: 10px;
    margin-right: 10px;
    width: calc((100% / 3) - 20px);
    height: 145px;
    position: relative;

    &:hover {
      .lens {
        visibility: visible;
      }
    }
    .lens {
      visibility: hidden;
      background: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      &:hover {
        visibility: visible;
      }
    }
  }
  @media (max-width: 1200px) {
    width: 100%;
  }
  @media (max-width: 630px) {
    flex-direction: column;
    .box {
      width: 83%;
      height: auto;
    }
  }
`;

export const OutlineWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  border: 1px solid black;
  border-right: none;
  margin-top: 8rem;
  margin-bottom: 5rem;

  @media (max-width: 1366px) {
    padding-right: 50px;
  }

  @media (max-width: 960px) {
    border: 1px solid black;
    border-top: none;
  }
`;

export const Box = styled.div`
  width: 100%;
  max-width: 701px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding-top: 4.3rem;
  padding-bottom: 4.3rem;

  .title {
    width: 69%;
  }
`;

export const NavigateButtons = styled.div`
  width: 100%;
  position: absolute;
  bottom: 2rem;
  display: flex;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 4rem;
  @media (max-width: 1200px) {
    position: fixed;
    bottom: 0;
    padding: 2rem 10%;
    background: transparent linear-gradient(0deg, #ffffff 0%, #ffffff00 100%) 0%
      0% no-repeat padding-box;
  }
`;

export const RedoButton = styled.button`
  width: 25rem;
  min-height: 6.2rem;
  position: relative;
  color: #ffffff;
  text-align: center;
  font-family: "Galano";
  font-size: calc(1.7rem * var(--font-size-scale));
  line-height: 2.3rem;
  letter-spacing: 0.17rem;
  text-transform: uppercase;
  background: #565656;
  font-weight: 300;
  margin-top: 6.5rem;
`;

export const Modal = styled.div`
  z-index: 99999999999999;
  position: absolute;
  height: max-content;
  background: #ffffff;
  max-height: 90%;
  top: 50%;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 15px 25px,
    rgba(0, 0, 0, 0.05) 0px 5px 10px;
  right: 50%;
  transform: translate(50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  & > img {
    width: max-content;
    max-width: 100%;
    height: max-content;
    max-height: 100%;
  }
`;
